import { render } from "./CardParty.vue?vue&type=template&id=6f871c66&ts=true"
import script from "./CardParty.vue?vue&type=script&lang=ts"
export * from "./CardParty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__